import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      key: 'cpxs-kj-pc',
      // paths: []
    })
  ],
  state: {
    token: '',
    config: {},
  },

  mutations: {
    setToken(state, value) {
      state.token = value
    },

    setConfig(state, value) {
      state.config = value
    }
  },

})